// extracted by mini-css-extract-plugin
module.exports = {"container":"ParentsTableCellsAddress_container__1v1Y5"};